import { Component, Input, AfterViewInit, ViewChild, ElementRef } from "@angular/core";
import {StepStateUpdater} from "../services/step/step-state";
import {CssSelection} from "../content/content-view.objects";
import {ClientConfiguration} from "../services/configuration/client.config";
import {PleaseWaitHiddenEvent, PleaseWaitTarget} from "../event/ContentEvents";
import {EventBus} from "../event/EventBus";
import {ComponentBase} from "../base/ComponentBase";
import {NavService} from "../services/nav/nav.service";
import {RaVersion} from "../services/configuration/ra.version";
import {BookIntroEndEvent} from "../event/ContentEvents";
import {AudioQueueEvent, InterruptAudio} from "../event/AudioQueueEvent";
import {AudioQueueItem, TranslateAudio} from "../services/audio-playback/audioqueue.item";
import {AudioQueueService} from "../services/audio-playback/audioqueue.service";
import {filter} from "rxjs/operators";

@Component({
    selector: "book-intro-view",
    templateUrl: "./book.intro.component.html",
               styleUrls: ["../reading/book.intro.component.scss"]
})
export class BookIntroComponent extends ComponentBase implements AfterViewInit {

    @ViewChild("coverImageElement") coverImageElement: ElementRef<any>;

    @Input()
    set content(value: CssSelection) {
        this.selection = value;
        this.title = value.metaData.fullTitle;
        this.description = value.metaData.introText;
        this.coverImage = this.config.introImageUrl(value.metaData.coverImage);
    }

    private selection: CssSelection;
    private bookIntroEnded: boolean = false;
    private introAudioPlayed: boolean = false;
    private DELAY_TO_PLAY_CLICK_START_BTN: number = 5000;
    public description: string;
    public coverImage: string;
    public title: string;
    public coverImageWidth: number;

    constructor(private stepStateUpdater: StepStateUpdater,
                private config: ClientConfiguration,
                private eventBus: EventBus,
                private navService: NavService,
                private audioQueueService: AudioQueueService) {
        super("BookIntroComponent");
        this.listenForPleaseWaitEnd();
    }


    ngAfterViewInit(): void {
        const img = new Image();
        img.onload = () => {
            if(!!this.coverImageElement.nativeElement.clientHeight){
                let aspectRatio = img.naturalWidth / img.naturalHeight;
                this.coverImageWidth = aspectRatio * this.coverImageElement.nativeElement.clientHeight;
            }
        };
        img.src = this.coverImage;
    }

    private listenForPleaseWaitEnd(): void {
        let pleaseWaitSub = this.eventBus.pipe(
            filter(e => e instanceof PleaseWaitHiddenEvent)).subscribe((e: PleaseWaitHiddenEvent) => {
            if (!this.bookIntroEnded && !this.introAudioPlayed && e.target === PleaseWaitTarget.READING) {
                this.playBookIntroSound();
                this.introAudioPlayed = true;
            } else {
                this.bookIntroEnded = false;
            }
        });
        this.subscriptions.push(pleaseWaitSub);
    }

    private startClickTheStartBtnTimer(): void {
        setTimeout(() => {
            if (!this.bookIntroEnded) {
                this.eventBus.next(new AudioQueueEvent([
                    new AudioQueueItem("RA_LIBRARY_05", TranslateAudio.YES)
                ], InterruptAudio.YES));
            }
        }, this.DELAY_TO_PLAY_CLICK_START_BTN);
    }

    private playBookIntroSound(): void {
        this.audioQueueService.reset().subscribe(() => {
            this.eventBus.next(new AudioQueueEvent(
                [   new AudioQueueItem(this.config.audioUrl + "SFX/RA_MAGIC_CHIME.mp3", TranslateAudio.NO),
                    new AudioQueueItem(this.config.audioUrl +
                                       this.selection.metaData.introAudio, TranslateAudio.NO, () => {
                        this.startClickTheStartBtnTimer();
                    })
                ], InterruptAudio.NO));
        });
    }

    public start(): void {
        this.bookIntroEnded = true;
        this.audioQueueService.hardReset();
        this.eventBus.next(new BookIntroEndEvent());
        this.stepStateUpdater.determineCurrentActivityAfterBookIntro();
    }

    public goToLibrary(): void {
        this.bookIntroEnded = true;
        this.audioQueueService.hardReset();
        this.navService.navigate(["library"]);
    }

}
